(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rita-mini-launch"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('rita-mini-launch')) {
    customElements.define('rita-mini-launch', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const track = this.querySelector('.rm-launch__track');
        const slides = [...this.querySelectorAll('.rm-launch__slide')];
        let current = 0;
        const go = (index) => {
          current = (index + slides.length) % slides.length;
          track.scrollTo({ left: slides[current].offsetLeft });
        };
        this.querySelector('[data-prev]').addEventListener('click', () => go(current - 1));
        this.querySelector('[data-next]').addEventListener('click', () => go(current + 1));
        track.addEventListener('scroll', () => {
          current = Math.round(track.scrollLeft / track.clientWidth);
          this.querySelector('[data-counter]').textContent = `${current + 1} / ${slides.length}`;
        }, { passive:true });
        this.addEventListener('shopify:block:select', (event) => {
          const selected = slides.indexOf(event.target.closest('.rm-launch__slide'));
          if (selected >= 0) go(selected);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
